export default "__VITE_ASSET__Bp0T58Rp__"